import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import FormResponseAudit from "./FormResponseAudit";
import { formatDate1 } from "./FormResponseAudit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import FormResponseFields from "./FormResponseFields";
import { FullLoader } from "./Loader";
import { fetchFormFieldDefinitions } from "../helpers/fetchFormFieldDefinitions";

function FormAccordion({ data: formResponse, editable, formData }) {
  const { userId, userRole } = useParams();
  const [formFieldsSections, setFormFieldsSections] = useState(null);

  useEffect(() => {
    if (!formData?.form_name) {
      setFormFieldsSections({});
      return;
    }

    let isCancelled = false;
    const token = localStorage.getItem("token");

    const loadFieldDefinitions = async () => {
      setFormFieldsSections(null);

      try {
        const definitions = await fetchFormFieldDefinitions({
          formName: formData.form_name,
          token,
          userId,
        });

        if (!isCancelled) {
          setFormFieldsSections(definitions);
        }
      } catch {
        if (!isCancelled) {
          setFormFieldsSections({});
        }
      }
    };

    loadFieldDefinitions();

    return () => {
      isCancelled = true;
    };
  }, [formData?.form_name, userId]);

  const isDefinitionsLoading = formFieldsSections === null;

  return (
    <>
      <FullLoader loading={isDefinitionsLoading} />
      <Accordion>
      {formResponse.map((item, index) => (
        <React.Fragment key={item?.id ?? index}>
          <Accordion.Item eventKey={String(index)}>
            <Accordion.Header>
              <div className="responses-header-row">
                <div className="responses-header-left">
                  <div className="responses-header-image">
                    <img
                      src={
                        item?.user.profile_photo
                          ? item?.user.profile_photo
                          : "/img/upload.jpg"
                      }
                      alt="response filling user"
                    />
                  </div>
                  <div className={"responses-header-detail"}>
                    <div className="d-flex">
                      <h5>{item?.user?.fullname}</h5>
                      {editable && (
                        <Link
                          style={{ marginLeft: "5px" }}
                          to={`/form/dynamic/${formData.form_name}`}
                          state={{
                            id: item?.id,
                            form_id: formData.form_id || null,
                            edit_from: "user",
                            user_id: userId,
                            user_role: userRole,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faPen}
                            style={{ color: "#455C58", marginRight: "10px" }}
                          />
                        </Link>
                      )}
                    </div>
                    <h6>
                      <span className="text-capitalize">{item?.user?.role}</span>
                    </h6>
                  </div>
                </div>
                <div className="responses-header-right">
                  {item?.updated ? (
                    <p>
                      Last updated By:&nbsp;&nbsp; {item?.updatedBy?.fullname}{" "}
                      <br />
                      Updated At: &nbsp;&nbsp; {formatDate1(item?.updatedAt)}
                    </p>
                  ) : (
                    <p>Created At: {formatDate1(item?.createdAt)}</p>
                  )}
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ paddingTop: "10px" }}>
              <div
                className={
                  index === 0
                    ? "responses-content-wrap"
                    : "responses-content-wrap response-margin"
                }
              >
                <div className="content-wrap-title text-capitalize d-md-flex">
                  <h4>
                    {item?.behalf_of?.fullname
                      ? `${item?.user?.fullname}`
                      : `Filled By: ${item?.user?.fullname}`}{" "}
                    {item?.behalf_of?.fullname
                      ? `| Name: ${item?.behalf_of?.fullname}`
                      : ``}
                  </h4>
                </div>
                <FormResponseFields
                  fields={item.fields}
                  formFieldsSections={formFieldsSections ?? {}}
                  definitionsReady={formFieldsSections !== null}
                />
              </div>
              <FormResponseAudit frData={item} />
            </Accordion.Body>
          </Accordion.Item>
        </React.Fragment>
      ))}
    </Accordion>
    </>
  );
}

export default FormAccordion;
